import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './index.css';
import loginpasswordbackground from '../../assets/background.png';
import loginpasswordlogo from '../../assets/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { ApiConstants } from '../../utils/apiConstants';
import { showToast } from '../../utils/toast';


const LoginPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    phoneNumber: '',
    password: ''
  });
  const [errors, setErrors] = useState({});


  const validate = () => {
    const newErrors = {};
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Enter a valid 10-digit phone number';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!validate()) {
      return;
    }

    setLoading(true);
    const loginUrl = `${ApiConstants.baseUrl}${ApiConstants.loginWithPassword}`;

    const requestBody = {
      phoneNumber: formData.phoneNumber.startsWith('+91') ? formData.phoneNumber : `+91${formData.phoneNumber}`,
      password: formData.password
    };

    console.log('API Call: Post', loginUrl);
    console.log('Request Body:', JSON.stringify(requestBody, null, 2));

    try {
      const response = await fetch(loginUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      const data = await response.json();
      console.log('API Response:', JSON.stringify(data, null, 2));

      if (response.ok || data.message === "Login successful") {
        showToast('Login successful', 'success');

        // Store tokens and user data
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('refreshToken', data.refresh_token);
        localStorage.setItem('userData', JSON.stringify(data.userData));

        // Navigate to home
        navigate('/');
      } else {
        const errorMsg = data.message || data.error || 'Login failed';
        let userFriendlyError = errorMsg;
        let fieldError = {};

        if (errorMsg.toLowerCase().includes('password')) {
          userFriendlyError = 'Invalid password. Please try again.';
          fieldError = { password: userFriendlyError };
        } else if (errorMsg.toLowerCase().includes('user') || errorMsg.toLowerCase().includes('phone') || errorMsg.toLowerCase().includes('found') || errorMsg.toLowerCase().includes('mobile')) {
          userFriendlyError = 'User not found. Please check the phone number or sign up.';
          fieldError = { phoneNumber: userFriendlyError };
        }

        showToast(userFriendlyError, 'error');
        setErrors(prev => ({ ...prev, ...fieldError, api: userFriendlyError }));
      }
    } catch (error) {
      console.error('Login Error:', error);
      showToast('An error occurred during login', 'error');
      setErrors({ api: 'An unexpected error occurred. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error for the field being changed
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
    if (errors.api) {
      setErrors(prev => ({ ...prev, api: '' }));
    }
  };
  return (
    <div className="login-password-container" style={{ backgroundImage: `url(${loginpasswordbackground})` }}>
      {/* Logo at top left */}
      <div className="login-password-logo-container">
        <div className="login-password-logo">
          <div className="login-password-logo-icon">
            {/* <img src={loginpasswordlogo} alt="CLAP KARTEL" className="login-password-film-reel-1" /> */}
          </div>
        </div>
      </div>

      {/* Glassmorphism Login Form */}
      <div className="login-password-form-wrapper">
        <div className="login-password-form-container">
          {/* Header */}
          <div className="login-password-header-section">
            <h2 className="login-password-title">Log in</h2>
            <div className="login-password-subtitle-logo-row">
              <p className="login-password-subtitle">Signin to Continue</p>
              <div className="login-password-form-logo">
                <div className="login-password-form-logo-icon">
                  <img src={loginpasswordlogo} alt="CLAP KARTEL" className="login-password-film-reel" />
                </div>
              </div>
            </div>
          </div>

          <form className="login-password-form" onSubmit={handleSubmit}>
            <div className="login-password-form-group">
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number (e.g. 9948811315)"
                value={formData.phoneNumber}
                onChange={handleChange}
                className={`login-password-form-input ${errors.phoneNumber ? 'error' : ''}`}
                disabled={loading}
              />
              {/* {errors.phoneNumber && <span className="login-password-error-text">{errors.phoneNumber}</span>} */}
            </div>

            <div className="login-password-form-group">
              <div className="login-password-password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  className={`login-password-form-input ${errors.password ? 'error' : ''}`}
                  disabled={loading}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="login-password-password-toggle"
                  disabled={loading}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
              {/* {errors.password && <span className="login-password-error-text">{errors.password}</span>} */}
            </div>

            <div className="login-password-forgot-password-wrapper">
              <a onClick={() => navigate('/login')} className="login-password-forgot-password">Login With OTP</a>
            </div>

            {/* {errors.api && <div className="login-password-error-text" style={{ textAlign: 'center', marginBottom: '10px' }}>{errors.api}</div>} */}

            <button type="submit" className="login-password-login-button" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>

            <div className="login-password-signup-link">
              Don't have an Account? <Link to="/signup">Sign Up</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LoginPassword